const style = {
  updateFirstAndLastNameForm__notificationMessage: {
    marginBottom: '10px',
  },
};

export default style;
